import { Image } from '@mui/icons-material'
import { Box, CircularProgress, Dialog, Typography } from '@mui/material'
import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TabNavigation from 'src/components/UI/CustomUI/organisms/TabNavigation'
import { itemsActions } from 'src/ducks/actions'
import {
    employeeIsReadOnly,
    getInspectionItems,
    getItemsSortedByCategory
} from 'src/ducks/selectors'
import { Item } from 'src/ducks/types'
import EstimateInfo from '../Items/OrderItems/Modals/AddItem/Tabs/EstimateInfo'
import ImageGallery from '../Items/OrderItems/Modals/AddItem/Tabs/ImageGallery'
import styles from './styles.module.scss'
type Props = {}

const InspectionItems = (props: Props) => {
  const [loading, setLoading] = useState('')
  const [selectedItem, setSelectedItem] = useState<Item | null>(null)
  const [openModal, setOpenModal] = useState(false)
  const dispatch = useDispatch()
  const inspectionItems = useSelector(getInspectionItems())

  const items = useSelector(getItemsSortedByCategory())

  const isReadOnly = useSelector(employeeIsReadOnly)

  const getCategoryItems = (category: string) => {
    return items.find((item) => item.category === category)
  }

  const handleCreateInspectionItem = (itemToCreate: Item) => {
    setLoading(itemToCreate.id?.toString() || '')
    const newItem = {
      hideFromClient: itemToCreate.hideFromClient,
      totalLaborCost: itemToCreate.totalLaborCost,
      totalMaterialCost: itemToCreate.totalMaterialCost,
      unitMaterialCost: itemToCreate.unitMaterialCost,
      unitLaborHours: itemToCreate.unitLaborHours,
      laborRate: itemToCreate.laborRate,
      category: itemToCreate.category,
      severity: itemToCreate.severity,
      title: itemToCreate.title,
      totalCost: itemToCreate.totalCost,
      profit: itemToCreate.profit,
      measurement: itemToCreate.measurement,
      inspectionReportNote: itemToCreate.inspectionReportNote,
      requestedRepairNote: itemToCreate.requestedRepairNote,
      priceItemId: itemToCreate.priceItemId,
      orderId: itemToCreate.orderId,
      estimateId: itemToCreate.estimateId,
      quantity: itemToCreate.quantity,
      status: itemToCreate.status,
      totalPrice: itemToCreate.totalPrice,
      margin: itemToCreate.margin,
      disclaimer: itemToCreate.disclaimer,
      imageFiles: itemToCreate.imageFiles,
      isEstimate: true,
    }
    dispatch(
      itemsActions.createItem(newItem, (succ) => {
        setLoading('')
      })
    )
  }

  const isExising = (item: Item) => {
    const categoryItems = getCategoryItems(item.category)?.items
    return (
      categoryItems?.findIndex(
        (it) => it.inspectionReportNote === item.inspectionReportNote
      ) !== -1
    )
  }

  const TABS = useMemo(() => {
    if (!selectedItem) return []
    return [
      {
        label: 'Estimate Info',
        content: <EstimateInfo itemFromProps={selectedItem} fromInspection={true} />
      },
      {
        label: 'Image Gallery',
        content: <ImageGallery itemFromProps={selectedItem} />
      }
    ]
  }, [selectedItem])

  const handleSelectItem = (item: Item) => {
    setSelectedItem(item)
    setOpenModal(true)
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerItemRef}>Reference</div>
        <div className={styles.headerItemNotes}>Item</div>
        <div className={styles.headerItem}></div>
      </div>
      <div className={styles.body}>
        {inspectionItems.map((item, index) => {
          return (
            <div
              onClick={() => !isReadOnly && handleSelectItem(item)}
              className={`${styles.bodyItem} ${isExising(item) ? styles.existingBodyItem : ''
                } ${isReadOnly ? styles.disabledBodyItem : ''}`}
              key={index}
            >
              <div className={styles.bodyItemCellRef}>{item.id}</div>
              <div className={styles.bodyItemCellNotes}>
                <Typography component="span" style={{ position: 'relative' }}>
                  {`${item.inspectionReportNote} ${isExising(item) ? '(Summary)' : ''}`}
                  {item.imageFiles.length ? (
                    <div style={{ display: 'inline-flex', alignItems: 'center', height: '16px', marginLeft: '4px', position: 'absolute' }}>
                      <Image style={{ width: '14px', height: '14px' }} />
                    </div>
                  ) : (
                    <></>
                  )}
                </Typography>
              </div>
              <div className={styles.bodyItemCellButton}>
                <div
                  onClick={() => !isReadOnly && handleCreateInspectionItem(item)}
                  className={`${styles.addButton} ${isReadOnly ? styles.disabledButton : ''}`}
                >
                  {loading === item.id ? (
                    <CircularProgress color="info" size="1rem" />
                  ) : (
                    'Add'
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
      {openModal && selectedItem && <Dialog classes={{ paper: styles.root }} fullWidth open={openModal} onClose={() => setOpenModal(false)}>
        <Box className={styles.modalContainer}>
          <TabNavigation
            tabs={TABS}
            id='add-item-modal-tabs'
            variant="text"
            className={styles.TabNavigation}
          />
        </Box>
      </Dialog>}
    </div>
  )
}

export default InspectionItems
